import {
  startOfDay,
  startOfWeek,
  startOfMonth,
  endOfDay,
  subDays,
} from 'date-fns';

/** UI filter state for leads list (empty string / false = no filter). */
export const EMPTY_LEADS_UI_FILTERS = {
  channel: '',
  status: '',
  type: '',
  roomType: '',
  exclusivityStatus: '',
  dateCreated: '',
  dateCreatedFrom: '',
  dateCreatedTo: '',
  lastCalled: '',
  hasEmail: false,
  hasPhone: false,
  pipelineStage: '',
  sequenceEnrolled: '',
  splitApplies: false,
  agent: '',
  importLabel: '',
  eventTitle: '',
};

export function countActiveLeadsFilters(f) {
  let n = 0;
  if (f.channel) n += 1;
  if (f.status) n += 1;
  if (f.type) n += 1;
  if (f.roomType) n += 1;
  if (f.exclusivityStatus) n += 1;
  if (f.dateCreated || f.dateCreatedFrom || f.dateCreatedTo) n += 1;
  if (f.lastCalled) n += 1;
  if (f.hasEmail) n += 1;
  if (f.hasPhone) n += 1;
  if (f.pipelineStage) n += 1;
  if (f.sequenceEnrolled) n += 1;
  if (f.splitApplies) n += 1;
  if (f.agent) n += 1;
  if (f.importLabel) n += 1;
  if (f.eventTitle) n += 1;
  return n;
}

/**
 * Map UI filter state → api.leads.getAll() filter object (AND semantics).
 */
export function buildLeadsApiFilters(ui, { isRecruits = false } = {}) {
  const api = {};
  if (isRecruits) {
    api.type = 'recruit';
  } else {
    api.notType = 'recruit';
  }

  if (ui.channel) api.channel = ui.channel;
  if (ui.status) api.status = ui.status;
  if (ui.type) api.type = ui.type;
  if (ui.roomType) api.roomType = ui.roomType;
  if (ui.pipelineStage) api.pipelineStage = ui.pipelineStage;
  if (ui.importLabel) api.importLabel = ui.importLabel;
  if (ui.eventTitle) api.eventTitle = ui.eventTitle;
  if (ui.splitApplies) api.splitApplies = true;
  if (ui.hasEmail) api.hasEmail = true;
  if (ui.hasPhone) api.hasPhone = true;

  if (ui.exclusivityStatus === 'exclusive' || ui.exclusivityStatus === 'non_exclusive') {
    api.exclusivityStatus = ui.exclusivityStatus;
  } else if (ui.exclusivityStatus === 'pending_request') {
    api.exclusivityPending = true;
  }

  if (ui.sequenceEnrolled === 'enrolled' || ui.sequenceEnrolled === 'not_enrolled') {
    api.sequenceEnrolled = ui.sequenceEnrolled;
  }

  const now = new Date();
  if (ui.dateCreated === 'today') {
    api.createdAfter = startOfDay(now).toISOString();
    api.createdBefore = endOfDay(now).toISOString();
  } else if (ui.dateCreated === 'week') {
    api.createdAfter = startOfWeek(now, { weekStartsOn: 0 }).toISOString();
    api.createdBefore = endOfDay(now).toISOString();
  } else if (ui.dateCreated === 'month') {
    api.createdAfter = startOfMonth(now).toISOString();
    api.createdBefore = endOfDay(now).toISOString();
  } else if (ui.dateCreated === 'custom') {
    if (ui.dateCreatedFrom) api.createdAfter = startOfDay(new Date(ui.dateCreatedFrom)).toISOString();
    if (ui.dateCreatedTo) api.createdBefore = endOfDay(new Date(ui.dateCreatedTo)).toISOString();
  }

  if (ui.lastCalled === 'never') {
    api.lastCalledNever = true;
  } else if (ui.lastCalled === 'today') {
    api.lastCalledAfter = startOfDay(now).toISOString();
  } else if (ui.lastCalled === 'week') {
    api.lastCalledAfter = startOfWeek(now, { weekStartsOn: 0 }).toISOString();
  } else if (ui.lastCalled === 'over30') {
    api.lastCalledBefore = subDays(now, 30).toISOString();
    api.lastCalledIncludeNull = true;
  }

  return api;
}
